export default __webpack_public_path__ + "static/media/ready.8903de91.mp3";